import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { CountryWrapperComponent } from '../country/wrapper/country-wrapper.component';
import {
  CountryDefaultDirective,
  CountryDirective
} from '../country/directives';
import { CountryComponentRegistryService } from '../country/services';
import { CountryOptions, DEFAULT_COUNTRY_OPTIONS } from './config';
import { DisableForCountriesPipe, EnableForCountriesPipe } from './pipes';

@NgModule({
  declarations: [
    CountryWrapperComponent,
    CountryDefaultDirective,
    CountryDirective,
    DisableForCountriesPipe,
    EnableForCountriesPipe
  ],
  providers: [
    CountryComponentRegistryService,
    DisableForCountriesPipe,
    EnableForCountriesPipe
  ],
  imports: [CommonModule],
  exports: [
    CountryWrapperComponent,
    CountryDefaultDirective,
    CountryDirective,
    DisableForCountriesPipe,
    EnableForCountriesPipe
  ]
})
export class SparkCountryModule {
  //define static forRoot method to allow forRoot() to be called with options of type AggregatorComponentRegistryOptions
  static forRoot(
    options: CountryOptions = DEFAULT_COUNTRY_OPTIONS
  ): ModuleWithProviders<SparkCountryModule> {
    return {
      ngModule: SparkCountryModule,
      providers: [
        CountryComponentRegistryService,
        { provide: 'countryOptions', useValue: options }
      ]
    };
  }
}
